import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6 w-full" };
const _hoisted_2 = { class: "flex flex-col gap-6" };
const _hoisted_3 = { class: "flex flex-col gap-6" };
import Anthropometry from '@ts/components/analysis/Anthropometry.vue';
import ChartReference from '@ts/components/analysis/ChartReference.vue';
import Oxygen from '@ts/components/analysis/Oxygen.vue';
import Lactate from '@ts/components/analysis/Lactate.vue';
import Threshold from '@ts/components/analysis/Threshold.vue';
import Fat from '@ts/components/analysis/Fat.vue';
import Zones from '@ts/components/analysis/Zones.vue';
import ChartLactate from '@ts/components/analysis/ChartLactate.vue';
import ChartMetabolism from '@ts/components/analysis/ChartMetabolism.vue';
import ChartSubstrate from '@ts/components/analysis/ChartSubstrate.vue';
import {} from '@ts/common/datasets';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Report',
    props: {
        data: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(Anthropometry, {
                            ref: "anthropometry",
                            data: __props.data,
                            help: true
                        }, null, 8 /* PROPS */, ["data"]),
                        _createVNode(ChartReference, {
                            ref: "chartReference",
                            data: __props.data,
                            selectable: true,
                            help: true
                        }, null, 8 /* PROPS */, ["data"])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(Oxygen, {
                            ref: "oxygen",
                            data: __props.data,
                            help: true
                        }, null, 8 /* PROPS */, ["data"]),
                        _createVNode(Lactate, {
                            ref: "lactate",
                            data: __props.data,
                            help: true
                        }, null, 8 /* PROPS */, ["data"]),
                        _createVNode(Threshold, {
                            ref: "threshold",
                            data: __props.data,
                            help: true
                        }, null, 8 /* PROPS */, ["data"]),
                        _createVNode(Fat, {
                            ref: "fat",
                            data: __props.data,
                            help: true
                        }, null, 8 /* PROPS */, ["data"])
                    ]),
                    _createVNode(Zones, {
                        ref: "zones",
                        class: "lg:col-span-2",
                        data: __props.data,
                        help: true
                    }, null, 8 /* PROPS */, ["data"]),
                    _createVNode(ChartLactate, {
                        ref: "chartLactate",
                        class: "lg:col-span-2",
                        data: __props.data,
                        help: true
                    }, null, 8 /* PROPS */, ["data"]),
                    _createVNode(ChartMetabolism, {
                        ref: "chartMetabolism",
                        class: "lg:col-span-2",
                        data: __props.data,
                        help: true
                    }, null, 8 /* PROPS */, ["data"]),
                    _createVNode(ChartSubstrate, {
                        ref: "chartSubstrate",
                        class: "lg:col-span-2",
                        data: __props.data,
                        help: true
                    }, null, 8 /* PROPS */, ["data"])
                ])
            ]));
        };
    }
});
